import Dialog from "@mui/material/Dialog";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import * as React from "react";
import { BootstrapButton } from "../components/styledcomponents";
import { Reciept } from "./reciept";
import "./style.scoped.css";

export function TransDetailDailog({ open, handleClose, data }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const { amount, date, transaction_type, uid } = data;

  React.useEffect(() => {
    console.log(data);
  });

  const isCredit = transaction_type === "Credit";

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        fullWidth={true}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <div className="modal-content modal-content-demo" bis_skin_checked={1}>
          <div className="modal-header" bis_skin_checked={1}>
            <h6 className="modal-title">Transaction Details</h6>
            <button
              aria-label="Close"
              className="close"
              onClick={handleClose}
              type="button"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body" bis_skin_checked={1}>
            <Reciept data={data} />
          </div>
          <div className="modal-footer" bis_skin_checked={1}>
            {/* <button className="btn ripple btn-primary" type="button">Save changes</button> */}
            <BootstrapButton
              variant="contained"
              onClick={handleClose}
              disableElevation
            >
              Close
            </BootstrapButton>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
